/**
 * SmartOfferCard — Renders FoodTruckCard or OfferCard based on listing_type.
 * Drop-in replacement wherever OfferCard is used in feed contexts.
 *
 * v1.0 Item 2 Decision 2: when `truck_features` flag is OFF, offers with
 * listing_type="food_truck" are hidden entirely (return null). Zero truck
 * presence at v1.0 — no downgraded cards, no partial truck content.
 */
import { useNavigate } from "react-router-dom";
import { OfferCard } from "@/components/shared/OfferCard";
import FoodTruckCard from "@/components/cards/FoodTruckCard";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

export default function SmartOfferCard({ offer, userCity, isFavorited, onToggleFavorite, onShare, onClick }) {
  const navigate = useNavigate();
  const { flags } = useFeatureFlags();

  if (offer?.listing_type === "food_truck") {
    if (!flags.truck_features) return null;
    return (
      <FoodTruckCard
        business={offer}
        isFavorited={isFavorited}
        onToggleFavorite={onToggleFavorite}
        onShare={onShare}
      />
    );
  }

  // Default: standard brick-and-mortar / social-only card
  return (
    <OfferCard
      offer={offer}
      onClick={onClick || (() => navigate(`/offer/${offer?.business_id}`))}
      userCity={userCity}
    />
  );
}
